"use client";

import { useState, useCallback, useEffect } from "react";

const STORAGE_KEY = "meex_recent_searches";
const MAX_RECENT = 3;

function readFromStorage() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
  } catch {
    return [];
  }
}

export function useRecentSearches() {
  const [recentSearches, setRecentSearches] = useState([]);

  // Load on mount (client-only — localStorage unavailable during SSR)
  useEffect(() => {
    setRecentSearches(readFromStorage());
  }, []);

  const save = useCallback((query) => {
    if (!query?.trim()) return;
    const q = query.trim();
    setRecentSearches((prev) => {
      const deduplicated = [q, ...prev.filter((r) => r !== q)].slice(
        0,
        MAX_RECENT,
      );
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(deduplicated));
      } catch {}
      return deduplicated;
    });
  }, []);

  const remove = useCallback((query) => {
    setRecentSearches((prev) => {
      const updated = prev.filter((r) => r !== query);
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
      } catch {}
      return updated;
    });
  }, []);

  const clear = useCallback(() => {
    setRecentSearches([]);
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch {}
  }, []);

  return { recentSearches, save, remove, clear };
}
